import * as React from "react";
import { Path } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

export const Whatsapp = (props: IIconProps) => {
  return (
    <Icon viewBox="0 0 24 24" {...props}>
      <Path
        d="M20.16 6.84C17.28 2.4 11.4 1.08 6.83998 3.84C2.39998 6.6 0.95998 12.6 3.83998 17.04L4.07998 17.4L3.11998 21L6.71998 20.04L7.07998 20.28C8.63998 21.12 10.32 21.6 12 21.6C13.8 21.6 15.6 21.12 17.16 20.16C21.6 17.28 22.92 11.4 20.16 6.84V6.84ZM17.64 16.08C17.16 16.8 16.56 17.28 15.72 17.4C15.24 17.4 14.64 17.64 12.24 16.68C10.2 15.72 8.51998 14.16 7.31998 12.36C6.59998 11.52 6.23998 10.44 6.11998 9.36C6.11998 8.4 6.47998 7.56 7.07998 6.96C7.31998 6.72 7.55998 6.6 7.79998 6.6H8.39998C8.63998 6.6 8.87998 6.6 8.99998 7.08C9.23998 7.68 9.83998 9.12 9.83998 9.24C9.95998 9.36 9.95998 9.6 9.83998 9.72C9.95998 9.96 9.83998 10.2 9.71998 10.32C9.59998 10.44 9.47998 10.68 9.35998 10.8C9.11998 10.92 8.99998 11.16 9.11998 11.4C9.59998 12.12 10.2 12.84 10.8 13.44C11.52 14.04 12.24 14.52 13.08 14.88C13.32 15 13.56 15 13.68 14.76C13.8 14.52 14.4 13.92 14.64 13.68C14.88 13.44 15 13.44 15.24 13.56L17.16 14.52C17.4 14.64 17.64 14.76 17.76 14.88C17.88 15.24 17.88 15.72 17.64 16.08V16.08Z"
        fill="currentColor"
      />
    </Icon>
  );
};

export default Whatsapp;
